import { AuthProvider as OidcAuthProvider } from 'react-oidc-context'
import { oidcConfig } from './oidc'

interface Props {
  children: React.ReactNode
}

/**
 * AuthProvider wraps the application with the OIDC context.
 * It must be placed above any component that calls useAuth().
 */
export function AuthProvider({ children }: Props) {
  return (
    <OidcAuthProvider {...oidcConfig}>
      {children}
    </OidcAuthProvider>
  )
}
